"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@ui-propulsion/react-components");
var _propTypes = require("prop-types");
var _InfoDetailSection = _interopRequireDefault(require("../InfoDetailSection"));
var _utils = require("../../utils");
var DisbursementInfo = function DisbursementInfo(_ref) {
  var disbursementDate = _ref.disbursementDate,
    disbursedAmount = _ref.disbursedAmount,
    feeRate = _ref.feeRate,
    netPracticeFee = _ref.netPracticeFee,
    caseSizeSavings = _ref.caseSizeSavings,
    amountFinanced = _ref.amountFinanced;
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    className: "disbursement-info",
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund__section-title"
  }, "DISBURSEMENT INFORMATION"), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Complete Date:",
    detail: _utils.dateFormatter.format(new Date(disbursementDate))
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Amount Financed:",
    detail: (0, _utils.toDollar)(amountFinanced)
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Amount Disbursed:",
    detail: (0, _utils.toDollar)(disbursedAmount)
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Net Practice Fee:",
    detail: (0, _utils.toDollar)(netPracticeFee)
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Practice Fee:",
    detail: "".concat((0, _utils.toFixedPrecisionTwo)(feeRate * 100), "%")
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Case Size Savings:",
    detail: "".concat(!caseSizeSavings ? 'N/A' : (0, _utils.toDollar)(caseSizeSavings))
  })));
};
DisbursementInfo.propTypes = {
  disbursementDate: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
  disbursedAmount: _propTypes.string.isRequired,
  amountFinanced: _propTypes.string.isRequired,
  feeRate: _propTypes.number.isRequired,
  netPracticeFee: _propTypes.string.isRequired,
  caseSizeSavings: _propTypes.number.isRequired
};
var _default = DisbursementInfo;
exports.default = _default;
